import {
  IdentityProviderConfigurationRequest,
  IdentityProviderConfigurationResponse as IdpConfigResponse,
  IdentityProviderConfigurationsResponse,
  SamlProviderConfig,
  ProvisionerTask,
} from '@tanium-cloud/tsp-contracts';
import { getApiClient } from '../apiClient';

const idp = {
  addConfiguration: async (request: IdentityProviderConfigurationRequest): Promise<IdpConfigResponse> => {
    const apiClient = getApiClient();
    const { data } = await apiClient.post<IdpConfigResponse>('/api/idp-setup/configuration', request);
    return data;
  },
  updateConfiguration: async (request: IdentityProviderConfigurationRequest): Promise<IdpConfigResponse> => {
    const apiClient = getApiClient();
    const { data } = await apiClient.put<IdpConfigResponse>(
      `/api/idp-setup/configuration/${encodeURIComponent(request.name!)}`,
      request
    );
    return data;
  },
  getConfigurations: async (): Promise<IdentityProviderConfigurationsResponse> => {
    const apiClient = getApiClient();
    const { data } = await apiClient.get<IdentityProviderConfigurationsResponse>('/api/idp-setup/configuration');
    return data;
  },
  getMetadata: async (): Promise<SamlProviderConfig> => {
    const apiClient = getApiClient();
    const { data } = await apiClient.get<SamlProviderConfig>('/api/idp-setup/service-provider-metadata');
    return data;
  },
};

const task = {
  getStatus: async (taskId: number): Promise<ProvisionerTask> => {
    const apiClient = getApiClient();
    const { data } = await apiClient.get<ProvisionerTask>(`/api-public/tasks/${taskId}/status`);
    return data;
  },
};

export const Api = {
  idp,
  task,
};
